export default "__VITE_ASSET__DNOzxuHt__"